import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';


@Component({
    selector: 'app-svg-icon',
    imports: [],
    template: '',
    styleUrls: ['./svg-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgIconComponent {
  @HostBinding('style.mask-image')
  protected _path!: string;

  @Input()
  public set path(filePath: string) {
    this._path = `url("${filePath}")`;
  }
}
